const firebaseConfig = {
    apiKey: "AIzaSyAnL9t_MdlCEtPSORQoO5cqxjjweRuiqKc",
    authDomain: "doctors-portal-955b8.firebaseapp.com",
    databaseURL: "https://doctors-portal-955b8.firebaseio.com",
    projectId: "doctors-portal-955b8",
    storageBucket: "doctors-portal-955b8.appspot.com",
    messagingSenderId: "464080834466",
    appId: "1:464080834466:web:0e691c625bb48ac5a22cfb"
};

export default firebaseConfig;  